import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// AFTER App on purpose. webpack extracts CSS in module-graph order, not import-statement order
// (which is how the auth pages ended up beige on 2026-10-15), so importing the shared layers after
// everything App pulls in is what gives them the last word when specificity ties.
import './styles/buttons.css';
import './styles/forms.css';
import './styles/stats.css';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="320058445002-lddk8d48h06bei48bh6u08ku97t1i3kd.apps.googleusercontent.com">
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
